module.exports = __webpack_public_path__ + "static/media/menu.1bc3ee6c.svg";